const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./search/refinements'));
    processInclude(require('./search/pagination'));
    processInclude(require('./components/readmore'));
    processInclude(require('bulk/bulkorder/bulkorder'));
    processInclude(require('./wineClub/wineClub.js'));
});
